//@ts-ignore
// @ts-nocheck
import { types, getSnapshot, cast } from "mobx-state-tree";

const SingleBookingStage = types.model("SingleBookingStage", {
  stage: types.enumeration("CurrentBookingStatus", [
    "pending_response",
    "get_contact",
    "call_client",
    "submitted_feedback",
    "booked_lessons",
  ]),
  duration: types.maybeNull(types.string),
});

export const FeedbackStore = types.model("FeedbackStore", {
  callSummary: types.optional(types.string, ""),
  startDate: types.optional(types.string, ""),
});

export const BookingDurationStore = types
  .model("BookingDuration", {
    from: types.optional(types.string, ""),
    to: types.optional(types.string, ""),
    bookingUrl: types.optional(types.string, ""),
  })
  .views((self) => {
    return {
      get start_date() {
        return self.from;
      },
      get end_date() {
        return self.to;
      },
    };
  });

const BookingStageStore = types
  .model("BookingStageStore", {
    current: types.optional(
      types.enumeration("BookingStatus", [
        "pending_response",
        "get_contact",
        "call_client",
        "submitted_feedback",
        "booked_lessons",
      ]),
      "pending_response",
    ),
    stages: types.optional(types.array(SingleBookingStage), []),
  })
  .views((self) => {
    return {
      stepExists(status) {
        return self.stages.find((o) => o.stage == status);
      },
      get bookedDate() {
        let feedback_stage = this.stepExists("submitted_feedback");
        if (feedback_stage) {
          return feedback_stage.duration;
        }
      },
      get dateSubmitted() {
        let pending_response_stage = this.stepExists("pending_response");
        if (pending_response_stage) {
          return pending_response_stage.duration;
        }
      },
      get summary() {
        return getSnapshot(self);
      },
    };
  })
  .actions((self) => {
    const toNextStage = () => {
      let orders = {
        pending_response: "get_contact",
        get_contact: "call_client",
        call_client: "submitted_feedback",
        submitted_feedback: "booked_lessons",
      };
      let currentTime = new Date().toISOString();
      let nextStep = orders[self.current];
      // ensure that the current item exists in the array and also also
      // ensure that the next item is added to the array.
      if (nextStep) {
        if (self.stepExists(self.current)) {
          if (!self.stepExists(nextStep.stage)) {
            self.stages.push({ stage: nextStep.stage, duration: currentTime });
          }
        } else {
          self.stages.push({ stage: self.current, duration: currentTime });
          if (!self.stepExists(nextStep.stage)) {
            self.stages.push({ stage: nextStep.stage, duration: currentTime });
          }
        }
      } else {
      }
    };
    function updateCurrentStep(
      previousStep,
      currentStep,
      dateSubmitted,
      revert = false,
    ) {
      let currentTime = dateSubmitted || new Date().toISOString();
      let _previousStep = self.current;
      self.current = currentStep;
      let previousSnapshot = getSnapshot(self.stages);
      if (!self.stepExists(previousStep)) {
        self.stages.push({ stage: previousStep, duration: currentTime });
      }
      let currentSnapshot = getSnapshot(self.stages);
      if (revert) {
        self.stages = cast(previousSnapshot);
        self.current = _previousStep;
      }
      return { stages: currentSnapshot, current: currentStep };
    }
    function providedResponseToRequest(dateSubmitted, revert) {
      return updateCurrentStep(
        "pending_response",
        "get_contact",
        dateSubmitted,
        revert,
      );
    }
    function receivedClientContacts(dateSubmitted, revert) {
      return updateCurrentStep(
        "get_contact",
        "call_client",
        dateSubmitted,
        revert,
      );
    }
    function contactedClient(dateSubmitted, revert) {
      return updateCurrentStep(
        "call_client",
        "submitted_feedback",
        dateSubmitted,
        revert,
      );
    }
    function providedFeedbackOnMeetingWithClient(dateSubmitted, revert) {
      return updateCurrentStep(
        "submitted_feedback",
        "booked_lessons",
        dateSubmitted,
        revert,
      );
    }

    return {
      providedResponseToRequest,
      receivedClientContacts,
      contactedClient,
      providedFeedbackOnMeetingWithClient,
    };
  });

export default BookingStageStore;
